import styled from "styled-components"

import padding from "../../global/padding"

export const StyledFeedItem = styled.div`
  position: relative;
  padding: ${padding.tiny};
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    padding: ${padding.base};
  `}
  transition: background-color .24s;
  border-bottom: 1px solid ${({theme}) => theme.colors.greys.light};
`
